import { render, staticRenderFns } from "./AdvogadoInput.vue?vue&type=template&id=fb41e4d4&"
import script from "./AdvogadoInput.vue?vue&type=script&lang=js&"
export * from "./AdvogadoInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports